import { create } from 'zustand';

/**
 * «C'e' una schermata di PARTITA montata sotto?», per chi non puo' chiederlo.
 *
 * ⚠️ **Questo store esiste per cio' che NON importa.** Oltre a `zustand` non ha
 * un solo import — nemmeno di tipi — e deve restare cosi'.
 *
 * La revisione ([GameReplay]) offre «Analizza partita», che apre la damiera
 * d'analisi su `game-store` RISCRIVENDOLO (`startLocalGameFromBoard`). Deve
 * quindi sapere se qualcuno sta ancora disegnando da quello store; e non puo'
 * saperlo da se', perche' la risposta vive in `multiplayer-store`,
 * `arena-store`, `tournament-store` e `game-store`, che tirano dentro
 * `services/socket`, `services/api` e `@draughts/core`. Importarli dalla
 * revisione significherebbe ficcare il motore e la socket nel chunk della
 * revisione, e far esplodere i suoi test, che mockano `@draughts/core` con una
 * *factory* che espone solo `createInitialBoard`/`formatMoveNotation`.
 *
 * Quindi: **App pubblica il fatto, la revisione lo legge.** Nessuna prop da
 * passare a mano lungo sei punti di montaggio — ed e' esattamente il difetto che
 * questo store ripara: dei cinque ospiti della revisione la prop la riceveva in
 * due, e il bottone non compariva nei tornei, nelle arene e nel profilo aperto
 * in overlay.
 *
 * La regola che App applica e' `laSchermataUsaLoStoreDiPartita`
 * (utils/partita-in-corso.ts), e il perche' sia «schermata montata» e non
 * «partita in corso» sta scritto la'.
 */
interface SchermataDiPartitaStore {
  /**
   * Sotto c'e' una schermata che disegna da `game-store`. **Lo scrive SOLO
   * App**, che e' l'unico posto da cui si vede la schermata corrente; qui ci
   * arriva attraverso `usePubblicaSchermataDiPartita`.
   *
   * Parte da `false` di proposito: finche' App non ha pubblicato niente il modo
   * di sbagliare e' «l'azione e' disponibile», non «l'azione e' sparita».
   */
  montata: boolean;
  setMontata: (montata: boolean) => void;
}

export const useSchermataDiPartitaStore = create<SchermataDiPartitaStore>((set) => ({
  montata: false,
  setMontata: (montata) => set({ montata }),
}));
